import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell
} from 'recharts';

const GraficoContasPorDia = ({ dados = [] }) => {
  const cores = [
    'var(--chart-1, #4f8cff)',
    'var(--chart-2, #23b5d3)',
    'var(--chart-3, #34d399)',
    'var(--chart-4, #f59e0b)',
    'var(--chart-5, #8b5cf6)',
    'var(--chart-6, #06b6d4)',
    'var(--chart-7, #84cc16)',
  ];

  const formatarValorCompacto = (valor = 0) => {
    const absoluto = Math.abs(valor);
    if (absoluto >= 1000000) return `R$ ${(valor / 1000000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}M`;
    if (absoluto >= 1000) return `R$ ${(valor / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}k`;
    return `R$ ${valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}`;
  };

  const dadosChart = dados.map((item, index) => ({ ...item, isPrimeiroDia: index === 0 }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const isPrimeiroDia = data.isPrimeiroDia;
      
      return (
        <div className="bg-[color:var(--surface)] text-[color:var(--text-primary)] p-3 rounded-lg shadow-lg border border-[color:var(--border)]">
          <div className="font-semibold">{label}</div>
          <div className="text-[color:var(--accent)] font-medium">
            R$ {payload[0].value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </div>
          <div className="text-[color:var(--text-muted)]">
            {data.contas} conta{data.contas !== 1 ? 's' : ''}
          </div>
          {isPrimeiroDia && (
            <div className="text-[color:var(--status-bad,var(--text-primary))] text-xs mt-1 border-t border-[color:var(--border)] pt-1">
              *Inclui contas vencidas
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-[color:var(--surface)] border border-[color:var(--border)] rounded-lg p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-[color:var(--text-primary)] mb-1">Contas a Pagar por Dia</h3>
      <p className="text-xs sm:text-sm text-[color:var(--text-muted)] mb-3 sm:mb-4">
        Passe o mouse sobre as colunas para ver detalhes.{' '}
        <span className="text-[color:var(--status-bad,var(--text-primary))] font-medium">*Primeiro dia inclui contas vencidas.</span>
      </p>
      
      <div className="h-44 sm:h-52 md:h-64">
        {dadosChart.length === 0 ? (
          <div className="h-full flex items-center justify-center border border-dashed border-[color:var(--border)] rounded-lg bg-[color:var(--surface-muted)]">
            <p className="text-sm text-[color:var(--text-muted)]">Sem dados para o período selecionado.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dadosChart} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" />
              <XAxis 
                dataKey="dia" 
                tick={{ fontSize: 12, fill: 'var(--text-muted)' }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis 
                tick={{ fontSize: 12, fill: 'var(--text-muted)' }}
                axisLine={false}
                tickLine={false}
                tickFormatter={formatarValorCompacto}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(148, 163, 184, 0.08)' }} />
              <Bar dataKey="valor" radius={[4, 4, 0, 0]} activeBar={{ stroke: 'var(--accent)', strokeWidth: 1 }}>
                {dadosChart.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={cores[index % cores.length]}
                    stroke={entry.isPrimeiroDia ? 'var(--status-bad, #ef4444)' : 'transparent'}
                    strokeWidth={entry.isPrimeiroDia ? 1.5 : 0}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
      
      <div className="mt-3 sm:mt-4">
        <p className="text-[11px] sm:text-xs text-[color:var(--text-muted)] mb-0.5">Total dos 7 dias</p>
        <p className="text-sm sm:text-base font-semibold text-[color:var(--text-primary)]">
          R$ {dados.reduce((total, item) => total + item.valor, 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
        </p>
      </div>
    </div>
  );
};

export default GraficoContasPorDia;



